<template>
  <section>
    <Divider class="mt-4 mb-4 bg-delta-grey" v-show="canWatchBasic" />
    <form v-show="canWatchBasic">
      <FormRow :fieldNameArr="[$t('GROUP_ACCOUNT'), $t('ROLE'), $t('SYSTEM'), $t('OA_CODE')]">
        <Input v-model="group.code" :disabled="true" slot="a" />
        <Input v-model="group.role.code" :disabled="true" slot="b" />
        <Input v-model="system" :disabled="true" slot="c" />
        <Input v-model="group.oaCode" :disabled="true" slot="d" />
      </FormRow>

      <FormRow :fieldNameArr="[$t('COMPANY_GROUP'), $t('COMPANY_NAME')]">
        <Input v-model="group.companyGroup" :disabled="true" slot="a" />
        <Input v-model="group.companyName" :disabled="true" slot="b" :style="{width:inputWidth(group.companyName)}" />
      </FormRow>
      <FormRow :fieldNameArr="[$t('COMPANY_ADDRESS'), $t('COUNTRY')]">
        <Input v-model="group.companyAddress" :disabled="true" slot="a" :style="{width:inputWidth(group.companyAddress)}" />
        <Input v-model="group.country" :disabled="true" slot="b" />
      </FormRow>

      <FormRow :fieldNameArr="[$t('GO_LIVE_DATE'), $t('CREATE_DATE'), $t('STATUS')]">
        <DatePicker
          class="datePicker"
          v-model="group.effectiveDate"
          type="date"
          format="yyyy-MM-dd"
          :placeholder="$t('GO_LIVE_DATE')"
          :disabled="!canUpdateBasic"
          @on-change="changeEffectiveDate"
          slot="a"
        ></DatePicker>
        <Input v-model="group.createDate" :disabled="true" slot="b" />
        <RadioGroup v-model="group.isLock" size="large" slot="c">
          <Radio label="true" :disabled="!canUpdateBasic">LOCK</Radio>
          <Radio label="false" :disabled="!canUpdateBasic">UNLOCK</Radio>
        </RadioGroup>
      </FormRow>

      <FormRow :fieldNameArr="[$t('REMARK')]">
        <Input
          v-model="group.remarks"
          class="longText"
          :maxlength="500"
          show-word-limit
          :disabled="!canUpdateBasic"
          :style="{width: 500 + 'px'}"
          slot="a"
        />
      </FormRow>

      <FormRow :fieldNameArr="[$t('REGION')]">
        <CheckboxGroup v-model="group.regionCodeList" size="large" slot="a">
          <Checkbox v-for="(item, index) in regionList" :key="index" :label="item.code" :disabled="!canUpdateBasic">
            {{ language == "en" ? item.name : item.description }}
          </Checkbox>
        </CheckboxGroup>
      </FormRow>

      <Card v-show="canWatchSpecialRole" :title="$t('SPECIAL_SETTINGS')" class="card-warning mt-3">
        <FormRow :fieldNameArr="[$t('SEND_TO_QUOTATION_OA_CODE')]">
          <Input v-model="group.quotationOaCode" ref="quotationOaCode" :maxlength="6" show-word-limit :disabled="!canUpdateBasic" slot="b" />
        </FormRow>
        <div class="flex-container">
          <div v-for="(specialFlagRole, index) in specialFlagRoleList" :key="index">
            <div class="item">
              <div class="inline">
                <span class="label"> {{ specialFlagRole.name }} </span>
              </div>
              <div class="inline">
                <i-switch
                  v-model="specialFlagRole.checked"
                  size="large"
                  true-value="Y"
                  false-value="N"
                  :disabled="!canUpdateSpecialRole"
                  slot="a"
                >
                  <span slot="open">{{$t('YES')}}</span>
                  <span slot="close">{{$t('NO')}}</span>
                </i-switch>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </form>
    <ButtonRow v-show="canUpdateBasic" >
      <Button type="primary" @click="createGroupAccount" slot="0" v-if="!isUpdate">{{$t('CREATE_ACCOUNT')}}</Button>
      <Button type="primary" @click="updateGroupAccount" slot="1" v-if="isUpdate">{{$t('UPDATE_ACCOUNT')}}</Button>
    </ButtonRow>
    <Divider class="mt-4 mb-4 bg-delta-grey" v-show="!canUpdateBasic && canWatchBasic" />
  </section>
</template>

<script>
import { AlertInfo } from "@/util/alert"
import { Translate } from "@/util/common"
import { mapGetters } from "vuex"
import { mapActions } from "vuex"

export default {
  name: "SupplierPart",
  props: {
    group: {
      type: Object,
      default: () => null,
    },
    regionList: {
      type: Array,
      default: () => null,
    },
    checkSpecialFlagRole: {
      type: Array,
      default: () => null,
    },
    specialFlagRoleList: {
      type: Array,
      default: () => []
    },
    isUpdate: {
      type: Boolean,
      default: () => false,
    },
    noGroupAccoutShow: {
      type: Boolean,
      default: () => false,
    },
    system: {
      type: String,
      default: () => "E-Procurement(EC) System"
    }
  },
  created() {
    if (!this.noGroupAccoutShow) {
      this.toggleLoading(true)
      this.$authHttp
        .post(
          "role/search/attribute",
          JSON.stringify({
            attributeDtos: [
              {
                key: "GROUP_PERSON",
                value: "Group",
              },
              {
                key: "SPECIAL_FLAG",
                value: "External",
              },
            ],
            paged: false,
          })
        )
        .then((response) => {
          this.toggleLoading(false)
          response.data._embedded.roleResourceList.forEach(roleResource => {
            this.specialFlagRoleList.push(roleResource);
          });
          this.specialFlagRoleList.forEach((role) => {
            if (this.checkSpecialFlagRole.includes(role.code)) {
              role.checked = "Y"
            } else {
              role.checked = "N"
            }
          })
        })
        .catch(() => {})
      this.group.regionCodeList = [];
      this.group.isLock = this.group.isLock === undefined ? "false" : this.group.isLock.toString();
      if (this.group.regions != undefined && this.group.regions != null) {
        this.group.regions.forEach(region => {
          this.group.regionCodeList.push(region.code);
        });
      }
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage"]),
    ...mapActions(["toggleLoading"]),
    changeEffectiveDate(value) {
      this.$emit("changeEffectiveDate", value)
    },
    async createGroupAccount() {
      let data = {
        code: this.group.code,
        oaCode: this.group.oaCode,
        effectiveDate: this.group.effectiveDate,
        isLock: this.group.isLock,
        remarks: this.group.remarks,
        regionCodeList: this.group.regionCodeList
      };
      this.$emit("createGroupAccount", data);
    },
    async updateGroupAccount() {
      if (!(await this.validationQuotationOaCode(this.group.quotationOaCode))) {
        return;
      }
      let data = {
        effectiveDate: this.group.effectiveDate,
        isLock: this.group.isLock,
        remarks: this.group.remarks,
        regionCodeList: this.group.regionCodeList,
        quotationOaCode: this.group.quotationOaCode,
        isCheckErp: this.group.role.attributes.find(attr => attr.key === "CHECK_ERP").value === "Y"
      };
      this.$emit("updateGroupAccount", data);
    },
    async validationQuotationOaCode(quotationOaCode) {
      if (!quotationOaCode || quotationOaCode == "V" || quotationOaCode == "v") {
        return true;
      }
      if (quotationOaCode.length !== 6) {
        AlertInfo(this, quotationOaCode + ": " + this.$t('OA_CODE_FORMAT_ERROR'))
          .then(() => {
            setTimeout(() => this.$refs['quotationOaCode'].focus(), 200);
          });
        return false;
      }
      let result = false;
      this.toggleLoading(true);
      await this.$vendorHttp
        .get("group-account/check-erp?code=" + quotationOaCode)
        .then(response => {
          this.toggleLoading(false);
          result = true;
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 444) {
            let text = this.$buildErrorMessage(error);
            this.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            });
          }
        });
      return result;
    }
  },
  computed: {
    language() {
      return this.getLanguage()
    },
    canUpdateBasic() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_CREATE_GROUP_ACCOUNT_AREA") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_BASIS_INFO_AREA_MODIFIABLE"))
      )
    },
    canWatchBasic() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_SEARCH_GROUP_ACCOUNT_AREA") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_BASIS_INFO_AREA_READONLY"))
      )
    },
    canUpdateSpecialRole() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_SPECIAL_INFO_AREA_MODIFIABLE")
      )
    },
    canWatchSpecialRole() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        (this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_SPECIAL_INFO_AREA_READONLY") ||
          this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_SPECIAL_INFO_AREA_MODIFIABLE"))
      )
    },
    inputWidth() {
      return function (value) {
        if (value === undefined || value === '' || value === 0) {
          return "100%";
        }
        return value.split("")
          .map(v => v.match(/[\u0000-\u00ff]/g) ? 0.5 : 1)
          .reduce((a, b) => a + b, 3) + "em";
      }
    }
  },
}
</script>

<style scoped>
</style>
